import PropTypes from 'prop-types'
import { Redirect } from 'react-router-dom'

import injectRole from '../../components/HOC/injectRole'
import { TRoles, TRoutes } from '../../shared/const'

import Communication from '../../components/views/admin/Communication'

/**
 * Kommunikation — nur für die Administration.
 *
 * Zeigt alle E-Mail-Vorlagen und internen Nachrichten, die die Anwendung an
 * SuS, LuL und Unterstützer:innen verschickt, samt Platzhaltern, Beispieldaten,
 * Auslöser und Änderungslog. Bearbeitungen schalten die Nachricht scharf.
 */
function CommunicationPage(props) {
	if ([TRoles.ADMIN, TRoles.FEDERAL_ADMIN].includes(props.role)) return <Communication />

	return <Redirect to={TRoutes.DASHBOARD} />
}

CommunicationPage.propTypes = {
	role: PropTypes.string.isRequired
}

export default injectRole(CommunicationPage)
